import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AnalyticsService } from './services/analytics.service';
import { GlobalErrorInterceptor } from './services/global-error.interceptor';
import { GlobalDomEventService } from './services/global-dom-event.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
    providers: [
        AnalyticsService,
        GlobalDomEventService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalErrorInterceptor,
            multi: true
        }
    ]
})
export class SingletonServicesModule {
    constructor(@Optional() @SkipSelf() parentModule: SingletonServicesModule) {
        if (parentModule) {
            throw new Error(
                'SingletonServicesModule is already loaded. Import it in AppModule only!'
            );
        }
    }
}
